import { Box, type SxProps } from '@mui/material';

interface Props {
  width?: number | string;
  height?: number | string;
  sx?: SxProps;
}

export const NWGreenIcon = ({ width = 20, height = 20, sx }: Props) => (
  <Box sx={sx}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.80079 3.5104C7.75639 3.4936 7.70879 3.4848 7.66039 3.4848H3.76879C3.61079 3.4848 3.48279 3.6128 3.48279 3.7708V7.8284L7.80039 3.5104H7.80079Z"
        fill="#00AE4D"
      />
      <path
        d="M3.56677 16.4316C3.61837 16.4832 3.68997 16.5152 3.76917 16.5152H7.54077C7.69877 16.5152 7.82677 16.3872 7.82677 16.2292V12.1716L3.56717 16.4312L3.56677 16.4316Z"
        fill="#00AE4D"
      />
      <path
        d="M12.17 7.82837V16.4788C12.1784 16.4828 12.1872 16.4864 12.196 16.4896L16.5136 12.172L12.17 7.82837Z"
        fill="#00682C"
      />
      <path
        d="M7.82682 12.172V3.52158C7.81842 3.51758 7.80962 3.51358 7.80082 3.51038L3.48322 7.82838V16.2296C3.48322 16.3084 3.51522 16.38 3.56682 16.4316L7.82682 12.172Z"
        fill="#8CCB32"
      />
      <path
        d="M16.5136 12.172V7.8284V3.7708C16.5136 3.6128 16.3856 3.4848 16.2276 3.4848H12.456C12.2984 3.4848 12.1704 3.6124 12.17 3.7704V7.8284L16.5136 12.172Z"
        fill="#8CCB32"
      />
      <path
        d="M16.5136 12.172L12.196 16.4896C12.2404 16.5064 12.288 16.5152 12.3364 16.5152H16.228C16.386 16.5152 16.514 16.3872 16.514 16.2292V12.1716L16.5136 12.172Z"
        fill="#8CCB32"
      />
      <path d="M7.82719 12.1716H7.82684V12.172L7.82719 12.1716Z" fill="#D0D1D3" />
      <path
        d="M7.94402 3.60201C7.91002 3.56801 7.86962 3.54121 7.82642 3.52161V12.172L12.0524 16.398C12.0868 16.4324 12.1268 16.4592 12.17 16.4788V7.82841L7.94402 3.60241V3.60201Z"
        fill="#00AE4D"
      />
    </svg>
  </Box>
);
